import { scaleBand, scaleLinear } from 'd3-scale';
import { createContext } from 'react';

import { CategoricalChartScales } from './CategoricalBarChartScalesContext.js';
import { ColoredChartDimension } from '../types/categorical-bar-chart-data.js';

export interface DisplayConfigProps extends CategoricalChartScales {
  highlightedDimension?: ColoredChartDimension;
}

export const DisplayConfigContext = createContext<DisplayConfigProps>({
  categoryScale: scaleBand(),
  valueScale: scaleLinear(),
  dimensionScale: scaleBand(),
});
